exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".no-transform{text-transform:inherit!important}.box-variacao i{cursor:pointer}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/itens/relacao.vue"],"names":[],"mappings":"AACA,cACE,gCAAkC,CACnC,AACD,gBACE,cAAe,CAChB","file":"relacao.vue","sourcesContent":["\n.no-transform{\n  text-transform: inherit!important;\n}\n.box-variacao i{\n  cursor: pointer\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41c5ad4b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/itens/relacao.vue
// module id = 617
// module chunks = 2